import React from 'react';
import {
  Card,
  Row,
  Col,
  Bubble
} from "tea-component";
import SvgIcon from '@/pages/home/components/SvgIcon';
import { DataSourceIcon } from '@/pages/home/pages/home/components/DataSource';
import { useIntl, history, getLocale } from 'umi';
import Abnormal from '@/pages/home/components/Abnormal';
import { changeURLStatic, homeDataSources, datamapIntelligenceSourcesPath } from '@/pages/home/utils/urlConfig';
import './DataSources.scss';

/** Col span=6 → 每行 4 列；仅最右列用 top-end，避免居中气泡被视口防溢出推偏 */
const DATASOURCE_COL_COUNT = 4;
/** 最右列气泡右移（Popper skidding, px） */
const RIGHTMOST_BUBBLE_SKIDDING_PX = 60;
/** 箭头相对全量反补后再右移的微调（px），与 skidding 一并注入 SCSS */
const RIGHTMOST_BUBBLE_ARROW_NUDGE_PX = 10;
const RIGHTMOST_BUBBLE_STYLE: React.CSSProperties = {
  '--dbh-datasource-bubble-skidding': `${RIGHTMOST_BUBBLE_SKIDDING_PX}px`,
  '--dbh-datasource-bubble-arrow-nudge': `${RIGHTMOST_BUBBLE_ARROW_NUDGE_PX}px`,
};

export default function DataSources(props: any) {
  const { loading, error } = props;
  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  // 数据源为前端静态有序配置，恒有数据
  const isNoData = false;
  // 是否在图标下方展示文字（保留原布局开关，默认关闭）
  const isRow = false;

  return (
    <Card className='home-card'>
      <Card.Body title={
        <div className='home-table-flex'
          onClick={() => {
            history.push(datamapIntelligenceSourcesPath);
          }}
        >
          <div className='home-table-title'>{formatMessage({ id: 'dbh_datasources' })}</div>
          <SvgIcon type='arrow-right' className='home-table-icon' />
        </div>
      }>
        <Abnormal
          isLoading={loading}
          isError={error}
          isNoData={isNoData}
          style={{ height: 250 }}
          component={<>
            <Row gap={24}>
              {homeDataSources?.map((item, index) => {
                const isRightmost = index % DATASOURCE_COL_COUNT === DATASOURCE_COL_COUNT - 1;
                return <Col key={item.iconType} span={isRow ? 8 : 6}>

                  <div className='sourcessflex'
                    onClick={() => {
                      changeURLStatic(item.path);
                    }}
                  > <Bubble
                      dark
                      placement={isRightmost ? 'top-end' : 'top'}
                      arrowPointAtCenter={!isRightmost}
                      placementOffset={
                        isRightmost ? [RIGHTMOST_BUBBLE_SKIDDING_PX, 10] : 10
                      }
                      className={
                        isRightmost
                          ? 'dbh-datasource-hover-bubble dbh-datasource-hover-bubble--end'
                          : 'dbh-datasource-hover-bubble'
                      }
                      style={isRightmost ? RIGHTMOST_BUBBLE_STYLE : undefined}
                      content={
                        <div style={{ whiteSpace: 'pre-line' }}>
                          {locale === 'zh-CN' ? item.hoverZh : item.hoverEn}
                        </div>
                      }
                    >
                      <DataSourceIcon className='sourcessicon' type={item.iconType} />
                      {isRow ? <div className='sourcesstext'>{item.iconType}</div> : ""}
                    </Bubble>
                  </div>

                </Col>;
              })}
            </Row>
          </>
          }
        />
      </Card.Body>
    </Card>

  );
};
